// frontend/src/components/notifications/NotificationToast.jsx
import React, { useState, useEffect } from 'react';
import { Toast, Button } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import { useNotifications } from '../../contexts/NotificationContext';
import styles from './NotificationToast.module.scss';

/**
 * 🍞 COMPONENTE DE TOAST PARA NOTIFICAÇÕES
 * 
 * Exibe notificações temporárias no canto da tela
 * com ações personalizáveis e auto-hide.
 */

const NotificationToast = ({ notification, onClose }) => {
  const [show, setShow] = useState(true);
  const { markAsRead, getNotificationActions, navigateToNotification } = useNotifications();

  useEffect(() => {
    // Auto-hide após 5 segundos por padrão
    const timer = setTimeout(() => {
      handleClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setShow(false);
    setTimeout(() => {
      if (!notification.read) {
        markAsRead(notification.id);
      }
      onClose?.(notification.id);
    }, 150); // Aguardar animação
  };

  const handleClick = () => {
    // Navegar para a demanda específica
    navigateToNotification(notification);
    
    if (notification.onClick) {
      notification.onClick(notification);
    }
    
    if (!notification.persistent) {
      handleClose();
    }
  };

  // Obter ações disponíveis para esta notificação
  const availableActions = getNotificationActions(notification);

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return 'agora';
    
    const now = new Date();
    const notificationTime = new Date(timestamp);
    const diff = now - notificationTime;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 1) return 'agora';
    if (minutes < 60) return `${minutes}min`;
    if (hours < 24) return `${hours}h`;
    return `${days}d`;
  };

  return (
    <Toast
      show={show}
      onClose={handleClose}
      className={`${styles.notificationToast} ${styles[notification.color] || styles.primary}`}
    >
      <Toast.Header className={styles.toastHeader} closeButton={false}>
        <div className={styles.headerContent}>
          <Icon 
            icon={notification.icon} 
            className={`${styles.icon} text-${notification.color}`}
          />
          <strong className={styles.title}>{notification.title}</strong>
          <small className={styles.timestamp}>{formatTimestamp(notification.timestamp)}</small>
        </div>
        <Button
          variant="link"
          size="sm"
          className={styles.closeButton}
          onClick={handleClose}
          title="Fechar notificação"
        >
          <Icon icon="mdi:close" />
        </Button>
      </Toast.Header>
      
      <Toast.Body 
        className={`${styles.toastBody} ${notification.onClick ? styles.clickable : ''}`}
        onClick={notification.onClick ? handleClick : undefined}
      >
        <div className={styles.message}>
          {notification.message}
        </div>

        {/* Ações de navegação - Removido botão Dashboard */}
        {availableActions && availableActions.length > 0 && (
          <div className={styles.actions}>
            {availableActions
              .filter(action => action.label !== 'Dashboard') // Remover botão Dashboard
              .map((action, index) => (
                <button
                  key={index}
                  className={styles.actionButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    action.onClick?.(notification);
                    if (action.closeOnClick !== false) {
                      handleClose();
                    }
                  }}
                >
                  {action.icon && <Icon icon={action.icon} className={styles.actionIcon} />}
                  {action.label}
                </button>
              ))}
          </div>
        )}

        {/* Debug Data removido conforme solicitado */}
      </Toast.Body>
    </Toast>
  );
};

export default NotificationToast;
























